import {
  TaskAction,
  TaskStatus,
} from '@principle-theorem/principle-core/interfaces';
import { IBaseEventFact, ITaskScopedFact } from './common';

export interface ITaskEventFact
  extends ITaskScopedFact,
    IBaseEventFact<TaskAction, TaskStatus> {}
